var _excluded = ["height", "width"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';

var IconEdit = function IconEdit(_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === void 0 ? 32 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 32 : _ref$width,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 33",
    fill: "none",
    width: width,
    height: height
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.88.084A5.495 5.495 0 0126.007 1a5.528 5.528 0 011.356 7.69L14.547 26.966 4 32.251l1.507-11.623 12.81-18.274a5.489 5.489 0 013.564-2.27zM13.2 25.406L25.724 7.54a3.524 3.524 0 00-.865-4.902 3.525 3.525 0 00-4.903.864L7.426 21.373l-.96 7.406 6.734-3.373z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.733 29a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM17.233 30.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z",
    fill: "currentColor"
  }));
};

IconEdit.propTypes = process.env.NODE_ENV !== "production" ? {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
} : {};
export default IconEdit;
//# sourceMappingURL=IconEdit.js.map